export default "__VITE_ASSET__D1Onkn8B__"